












































import {
  defineComponent,
  PropType,
  computed,
  ref,
  watch,
  inject,
} from '@vue/composition-api';
import { AppliedProperty, DictionaryForm, Word } from '@oare/types';
import utils from '@/utils';
import { ReloadKey } from '../../../../../index.vue';
import sl from '@/serviceLocator';
import PropertiesTree from '@/components/Properties/PropertiesTree.vue';

export default defineComponent({
  props: {
    word: {
      type: Object as PropType<Word>,
      required: false,
    },
    form: {
      type: Object as PropType<DictionaryForm>,
      required: true,
    },
    allowEditing: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    PropertiesTree,
  },
  setup(props) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');
    const reload = inject(ReloadKey);

    const editPropertiesDialog = ref(false);
    const formComplete = ref(false);

    const formGrammar = computed(() => utils.formGrammarString(props.form));

    const properties = ref<AppliedProperty[]>([]);
    const setProperties = (propertyList: AppliedProperty[]) => {
      properties.value = propertyList;
    };

    const addPropertiesKey = ref(false);
    watch(editPropertiesDialog, () => {
      if (editPropertiesDialog.value) {
        addPropertiesKey.value = !addPropertiesKey.value;
        properties.value = [];
      }
    });

    const updateFormProperties = async () => {
      try {
        await server.editPropertiesByReferenceUuid(
          props.form.uuid,
          properties.value,
          props.word ? props.word.uuid : undefined
        );
        actions.showSnackbar(
          `Successfully updated form parse info for ${props.form.form}`
        );
        reload && reload();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error updating form parse information.',
          err as Error
        );
      } finally {
        properties.value = [];
      }
    };

    const canEditParseInfo = computed(() =>
      store.hasPermission('EDIT_ITEM_PROPERTIES')
    );

    return {
      formGrammar,
      editPropertiesDialog,
      formComplete,
      properties,
      setProperties,
      addPropertiesKey,
      updateFormProperties,
      canEditParseInfo,
    };
  },
});
